// should be able to accept query parameters
import api from '../../utils/api';

// eslint-disable-next-line import/prefer-default-export
export const searchMedicines = async (params) => api.get('/search', { params });
